/**
 * Handling the Cookie Consent box
 */
let cookie_notice = () => {
    if( !document.getElementById('cookie_consent') ) return;

    const cookie_consent_box = document.getElementById('cookie_consent');

    // Check if the user has already accepted cookie consent or not
    if( localStorage.getItem('accepted_cookie_consent') ) {
        // Remove the Cookie Consent node from DOM all together
        cookie_consent_box.remove();
        return;
    }

    // Show the cookie consent to the user by changing the display property to flex
    cookie_consent_box.classList.add('d-flex');
    cookie_consent_box.classList.add('cv-visible');
    cookie_consent_box.classList.remove('d-none');
    cookie_consent_box.classList.remove('cv-hidden');

    // Check if the person clicks on the button and then receive the request and hide the consent box
    document.getElementById('cookie_consent_accept').addEventListener( 'click', (e) => {
        e.preventDefault();

        // Add data to the localStorage
        localStorage.setItem( 'accepted_cookie_consent', 'yes' );

        cookie_consent_box.remove();
    }, {
        capture: true,
        once: true
    });
};

document.addEventListener("DOMContentLoaded", function() {
    cookie_notice();
});